class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close(),
    );
    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this),
    );
    this.setHeaderCartIconAccessibility();

    this.updateHeightCartItems();
    window.addEventListener('resize', this.updateHeightCartItems.bind(this));
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
      this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add('animate', 'active');
      document.body.classList.add('drawer-open');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement =
          this.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      {once: true},
    );
    this.lockScroll();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    this.unlockScroll();
    document.body.classList.remove('drawer-open');
  }

  lockScroll(){
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollTop}px`;
    document.body.style.width = '100%';
  }

  unlockScroll(){
    const scrollY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id,
      );
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open'),
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    //console.log("PArsed State")
    // console.log(parsedState)
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener(
        'click',
        this.close.bind(this),
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }

  updateHeightCartItems() {
    const cartDrawers = document.querySelectorAll('cart-drawer');
    cartDrawers.forEach((cartDrawer) => {
      const cartItems = cartDrawer.querySelector('cart-drawer-items.has-protection-product-wrapper .cart-wrapper');
      const cartFooter = cartDrawer.querySelector('cart-drawer-items > .drawer__footer');
      const cartDrawerItem =  cartDrawer.querySelector('cart-drawer-items');
      if (cartFooter) {
        const isIOS = this.checkiOS();
        let cartFooterHeight = cartFooter.offsetHeight - 20;
        let cartDrawerItemHeight = 70;
        if (window.screen.width > 767) {
            cartDrawerItemHeight = 70;
          } else {
            cartDrawerItemHeight = 180;
          }
        if (!isIOS) {
          if (window.screen.width > 767) {
            cartDrawerItemHeight = 70;
            cartFooterHeight = cartFooter.offsetHeight;
          } else {
            cartDrawerItemHeight = 180;
            cartFooterHeight = cartFooter.offsetHeight - 110;
          }
        }
        if (cartItems) {
          cartItems.style.maxHeight = `calc(100% - ${cartFooterHeight}px)`;
        }
        if (cartDrawerItem) {
          cartDrawerItem.style.height = `calc(100vh - ${cartDrawerItemHeight}px)`;
        }
      }
    })
  }

  checkiOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }
}

customElements.define('cart-drawer', CartDrawer);


class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

if (!customElements.get('cart-protection-product')) {
  customElements.define('cart-protection-product',
    class CartProtectionProduct extends HTMLElement {
      constructor() {
        super();
        this.checkbox = this.querySelector('.cart-protection__checkbox');
        this.removeButton = this.querySelector('.cart-protection__remove');
        this.detailsButton = this.querySelector('button.cart-protection__details');

        if (this.checkbox) {
          this.checkbox.addEventListener('change', (event) => {
            // Keep cart-drawer-items from treating this as a quantity change
            event.stopPropagation();
            this.setProtection(this.checkbox.checked);
          });
        }
        if (this.removeButton) {
          this.removeButton.addEventListener('click', () => this.setProtection(false));
        }
        if (this.detailsButton) {
          this.detailsButton.addEventListener('click', this.toggleDetails.bind(this));
        }
      }

      connectedCallback() {
        if (this.hasAttribute('data-auto-add')) {
          this.setProtection(true, true);
        } else if (this.hasAttribute('data-auto-remove')) {
          this.setProtection(false, true);
        }
      }

      toggleDetails() {
        const info = document.getElementById(this.detailsButton.getAttribute('aria-controls'));
        if (!info) return;
        const isExpanded = this.detailsButton.getAttribute('aria-expanded') === 'true';
        this.detailsButton.setAttribute('aria-expanded', !isExpanded);
        info.hidden = isExpanded;
      }

      // Only the totals, footer and free-shipping bar depend on protection. Swapping just
      // those keeps the bag's scroll position and the picks slider from being rebuilt.
      renderTotals(cartItems, state, focusCheckbox) {
        const html = new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html');
        ['.free-shipping-progress', '.cart-drawer__footer', '.drawer__footer'].forEach((selector) => {
          const current = cartItems.querySelector(selector);
          const updated = html.querySelector(selector);
          if (current && updated) current.replaceWith(updated);
        });

        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          bubble.innerHTML = cartItems.getSectionInnerHTML(state.sections['cart-icon-bubble'], '.shopify-section');
        }

        if (focusCheckbox) {
          const checkbox = cartItems.querySelector('.cart-protection__checkbox');
          if (checkbox) checkbox.focus({ preventScroll: true });
        }
      }

      renderDrawer(cartItems, state) {
        cartItems.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
            state.sections[section.section],
            section.selector,
          );
        });
      }

      setProtection(enabled, isAuto = false) {
        const cartItems = this.closest('cart-drawer-items');
        if (!cartItems || cartItems.classList.contains('cart-protection--loading')) return;

        const variantId = this.dataset.variantId;
        const body = {
          updates: { [variantId]: enabled ? 1 : 0 },
          sections: cartItems.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        };
        // Remember an explicit choice so the default opt-in doesn't add it back
        if (!isAuto && this.hasAttribute('data-remember-decline')) {
          body.attributes = { _protection_declined: enabled ? '' : 'true' };
        }

        // Read before disabling the checkbox, which drops its focus
        const hadFocus = this.contains(document.activeElement);
        cartItems.classList.add('cart-protection--loading');
        if (this.checkbox) this.checkbox.disabled = true;

        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body: JSON.stringify(body)}})
          .then((response) => response.json())
          .then((state) => {
            if (state.status || state.errors) throw new Error(state.description || state.errors);
            const hasProtection = state.items.some((item) => String(item.variant_id) === variantId);
            if (hasProtection !== enabled) throw new Error('Package protection could not be updated');

            if (state.item_count === 0) {
              this.renderDrawer(cartItems, state);
            } else {
              this.renderTotals(cartItems, state, hadFocus);
            }
            cartItems.updateHeightCartItems();

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-items',
              cartData: state,
              variantId: variantId,
            });
            window.dispatchEvent(new CustomEvent('abra:render'));
          })
          .catch((error) => {
            console.error(error);
            if (this.checkbox) this.checkbox.checked = !enabled;
            const errors = document.getElementById('CartDrawer-CartErrors');
            if (errors && !isAuto) errors.textContent = window.cartStrings.error;
          })
          .finally(() => {
            cartItems.classList.remove('cart-protection--loading');
            if (this.checkbox) this.checkbox.disabled = false;
          });
      }
    }
  )
}
